module.exports = __webpack_public_path__ + "img/Mask Group 2918@2x.ccc3e515.png";